module.exports = __webpack_public_path__ + "img/map_yandex_ru.ab6211fc.jpg";